module.exports = __webpack_public_path__ + "img/User.8e10af2.svg";